import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { filter, includes, lowerCase } from 'lodash';
import { map, merge, Observable, startWith } from 'rxjs';

import { ThemeColor } from '../../../types/theme';
import { stringToColor } from '../../helpers/helpers';

@Component({
    selector: 'lui-tag-picker',
    templateUrl: './tag-picker.component.html',
    styleUrls: ['./tag-picker.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TagPickerComponent implements OnInit {
  @Input() public tags!: string[];
  @Input() availableTags!: string[];
  @Output() public tagsChange: EventEmitter<string[]> = new EventEmitter();

  public form!: FormGroup;
  public uniqTags!: Set<string>;

  filteredOptions$!: Observable<string[]>;

  get inputControl() {
    return this.form.get('name');
  }

  constructor(private readonly formBuilder: FormBuilder) {}

  public get canCreateTag(): boolean {
    return this.form.valid && !this.form.pristine;
  }

  public ngOnInit(): void {
    this.buildForm();
    this.buildTags(this.tags);

    if (this.inputControl) {
      this.filteredOptions$ = merge(
        this.inputControl.valueChanges,
        this.tagsChange.pipe(
          map(() => (this.inputControl ? this.inputControl.value : ''))
        )
      ).pipe(
        startWith(this.inputControl.value),
        map((v) =>
          filter(
            this.availableTags,
            (tag) =>
              includes(lowerCase(tag), lowerCase(v)) && !this.uniqTags.has(tag)
          )
        )
      );
    }
  }

  public createTag(): void {
    this.uniqTags.add(this.form.value.name);
    this.tagsChange.emit(Array.from(this.uniqTags));
    this.form.reset();
  }

  public getTagColor(tag: string): ThemeColor {
    return stringToColor(tag) as ThemeColor;
  }

  private buildForm(): void {
    this.form = this.formBuilder.group({
      name: [''],
    });
  }

  private buildTags(selectedTags: string[]): void {
    this.uniqTags = new Set(selectedTags);
  }
}
